import type { BirthNumberErrorCode } from '@/app/[locale]/order/_utils/validate-birth-number'

export const PATIENT_INFO_FORM_ID = 'order-patient-info-form'

export const ERR = {
	firstName: 'Meno je povinné',
	lastName: 'Priezvisko je povinné',
	email: {
		required: 'Email je povinný',
		invalid: 'Neplatný email'
	},
	phone: {
		required: 'Telefonický kontakt je povinný',
		invalid: 'Neplatné telefónne číslo'
	},
	birthNumber: {
		required: 'Rodné číslo je povinné',
		invalid: 'Neplatné rodné číslo (formát: 123456/123, 123456/1234 alebo 123456/0000)'
	},
	insurance: 'Vyberte poisťovňu',
	address: 'Adresa je povinná',
	city: 'Mesto je povinné',
	zipCode: {
		required: 'PSČ je povinné',
		invalid: 'Neplatné PSČ (formát: 123 45)'
	},
	countryId: 'Krajina je povinná',
	euInsuranceNumber: 'Identifikačné číslo poistenca je povinné',
	contractualInsurance: 'Zmluvné poistenie je povinné',
	privacyPolicy: 'Súhlas je povinný',
	terms: 'Súhlas je povinný'
} as const

export const BIRTH_NUMBER_ERROR_MESSAGES: Record<BirthNumberErrorCode, string> = {
	INVALID_FORMAT: 'Rodné číslo musí obsahovať 9 alebo 10 číslic',
	INVALID_MONTH: 'Rodné číslo obsahuje neplatný mesiac',
	INVALID_DAY: 'Rodné číslo obsahuje neplatný deň',
	FUTURE_DATE: 'Rodné číslo obsahuje neplatný dátum narodenia',
	INVALID_CHECK_DIGIT: 'Rodné číslo má neplatné kontrolné číslo',
	UNKNOWN: 'Neplatné rodné číslo'
}
